<template>
  <div class="main-header">
    <div class="main-header__container">
      <button
          type="button"
          class="main-header__logo-button"
          @click="goHome"
          aria-label="На главную"
      >
        <img :src="logoIcon" alt="ИнТелКом">
      </button>
      <button
          type="button"
          class="main-header__icon-button"
          :class="{ 'main-header__icon-button--disabled': loading }"
          :disabled="loading"
          @click="emitProfile"
          aria-label="Профиль"
      >
        <img :src="profileIcon" alt="Профиль">
      </button>

      <div class="main-header__info">
        <div v-if="loading" class="main-header__number main-header__number--skeleton"></div>
        <div v-else class="main-header__number">{{ displayNumber }}</div>
        <div class="main-header__caption">Номер договора</div>
        <button
            type="button"
            class="main-header__switch-button"
            :disabled="loading"
            @click="emitSwitchAccount"
        >
          Сменить или добавить аккаунт
        </button>
      </div>

      <div class="main-header__actions">
        <button
            type="button"
            class="main-header__icon-button"
            :class="{
              'main-header__icon-button--disabled': loading || !chatActive,
              'main-header__icon-button--inactive': !chatActive
            }"
            :disabled="loading || !chatActive"
            @click="emitSupport"
            aria-label="Чат с поддержкой"
        >
          <img :src="supportIcon" alt="Чат">
          <span v-if="chatBadge && !loading" class="main-header__badge"></span>
        </button>
        <button
            type="button"
            class="main-header__icon-button"
            :class="{ 'main-header__icon-button--disabled': loading }"
            :disabled="loading"
            @click="emitNotifications"
            aria-label="Уведомления"
        >
          <img :src="notificationsIcon" alt="Уведомления">
          <span v-if="notificationBadge && !loading" class="main-header__badge"></span>
        </button>
        <button
            type="button"
            class="main-header__icon-button"
            :class="{ 'main-header__icon-button--disabled': loading }"
            :disabled="loading"
            @click="emitLogout"
            aria-label="Выйти"
        >
          <img :src="logoutIcon" alt="Выход">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const LOGO_ICON = require('@/assets/ic_itk_logo.png');
const PROFILE_ICON = require('@/assets/ic_profile_redesign.svg');
const SUPPORT_ICON = require('@/assets/ic_chat_redesign.svg');
const NOTIFICATIONS_ICON = require('@/assets/ic_notifications.svg');
const LOGOUT_ICON = require('@/assets/ic_logout.svg');

export default {
  name: 'widget-header-main',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    number: {
      type: String,
      default: ''
    },
    chatBadge: {
      type: Boolean,
      default: false
    },
    notificationBadge: {
      type: Boolean,
      default: false
    },
    chatActive: {
      type: Boolean,
      default: true
    }
  },
  emits: ['profile', 'support', 'notifications', 'logout', 'switch-account'],
  computed: {
    logoIcon() {
      return LOGO_ICON
    },
    profileIcon() {
      return PROFILE_ICON
    },
    supportIcon() {
      return SUPPORT_ICON
    },
    notificationsIcon() {
      return NOTIFICATIONS_ICON
    },
    logoutIcon() {
      return LOGOUT_ICON
    },
    displayNumber() {
      if (!this.number || this.number.trim() === '') {
        return '—'
      }
      return this.number
    }
  },
  methods: {
    emitProfile() {
      if (this.loading) {
        return
      }
      this.$emit('profile')
    },
    emitSupport() {
      if (this.loading || !this.chatActive) {
        return
      }
      this.$emit('support')
    },
    emitNotifications() {
      if (this.loading) {
        return
      }
      this.$emit('notifications')
    },
    emitLogout() {
      if (this.loading) {
        return
      }
      this.$emit('logout')
    },
    emitSwitchAccount() {
      if (this.loading) {
        return
      }
      this.$emit('switch-account')
    },
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.main-header {
  grid-area: top-bar;
  width: 100%;
}

.main-header__container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 24px;
  background: linear-gradient(180deg, #67CEFF 0%, #0082BF 100%);
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  color: #ffffff;
}

.main-header__logo-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  height: 48px;
  border-radius: 16px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
}

.main-header__logo-button img {
  height: 28px;
  width: auto;
}

.main-header__logo-button:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.3);
}

.main-header__logo-button:focus-visible,
.main-header__icon-button:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.9);
  outline-offset: 2px;
}

.main-header__icon-button {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  border: none;
  background: rgba(255, 255, 255, 0.18);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.main-header__icon-button img {
  width: 28px;
  height: 28px;
}

.main-header__icon-button:hover:not(.main-header__icon-button--disabled) {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.28);
}

.main-header__icon-button--disabled {
  opacity: 0.5;
  cursor: default;
}

.main-header__icon-button--inactive {
  opacity: 0.7;
}

.main-header__icon-button--disabled.main-header__icon-button--inactive {
  opacity: 0.5;
}

.main-header__badge {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff6464;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.35);
}

.main-header__info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.main-header__number {
  font-family: 'Mont', serif;
  font-size: 2rem;
  font-weight: 900;
  line-height: 1.1;
}

.main-header__number--skeleton {
  height: 32px;
  width: 160px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.35);
  position: relative;
  overflow: hidden;
}

.main-header__number--skeleton::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.6s infinite;
}

.main-header__caption {
  font-family: 'Mont', serif;
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}

.main-header__switch-button {
  margin-top: 6px;
  align-self: flex-start;
  border: none;
  border-radius: 12px;
  padding: 6px 12px;
  font-family: 'Mont', serif;
  font-weight: 600;
  font-size: 0.85rem;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.22);
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.main-header__switch-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.32);
  transform: translateY(-1px);
}

.main-header__switch-button:disabled {
  opacity: 0.6;
  cursor: default;
}

.main-header__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@media (max-width: 768px) {
  .main-header__container {
    padding: 20px;
    gap: 12px;
  }

  .main-header__number {
    font-size: 1.6rem;
  }
}
</style>
